const createEmptyQuestion = () => {
  return {
    question_text: '',
    option1: '',
    option2: '',
    option3: '',
    option4: '',
    correct_option: null,
  }
}

export default createEmptyQuestion
